import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";
import UtilService from "../../../services/UtilService";

const AdminGridService = {
    requestPuzzle: async (pageModel, sort, keyword, setRows, setRowCount) => {
        let params = {
            page: pageModel.page,
            pageSize: pageModel.pageSize,
            sort: sort.map((s) => `${s.field}:${s.sort}`).join(","),
            keyword: keyword,
        };

        const result = await ApiService.getData("/v1/puzzle/hw", params);

        const mapped = result.content.map((r) => {
            return {
                id: r.id,
                title: r.title,
                letters: r.letters,
                state: r.state,
                "cloudUser.email": r.cloudUser.email,
                createdAt: UtilService.formatDate(r.createdAt),
            };
        });

        setRows(mapped);
        setRowCount(result.page?.totalElements ?? 0);
    },

    requestPuzzleDetail: async (gridId, setPuzzle) => {
        const result = await ApiService.getData(`/v1/puzzle/grid/${gridId}`);
        setPuzzle(result);
        return result;
    },

    requestPuzzlePlay: async (gridId, keyword, pageModel, sort, setRows, setRowCount, isCompleted, onlyStarted = false, testAccountFilter = "exclude", excludeStaff = true) => {
        let params = {
            page: pageModel.page,
            pageSize: pageModel.pageSize,
            sort: sort.map((s) => `${s.field}:${s.sort}`).join(","),
        };

        if (gridId) {
            params["gridId"] = gridId;
        }

        if (keyword) {
            params["keyword"] = keyword;
        }

        if (isCompleted !== null) {
            params["isCompleted"] = isCompleted;
        }

        if (onlyStarted === true) {
            params["onlyStarted"] = true;
        }

        if (testAccountFilter === "exclude") {
            params.testAccount = false;
        } else if (testAccountFilter === "include") {
            params.testAccount = true;
        }
        if (excludeStaff) {
            params.staff = false;
        }

        const result = await ApiService.getData(`/v1/puzzle/grid-play`, params);

        // Get puzzle type if gridId is provided
        let puzzleType = 'WORD_SEARCH'; // default
        if (gridId) {
            try {
                const puzzleDetail = await ApiService.getData(`/v1/puzzle/grid/${gridId}`);
                puzzleType = puzzleDetail.type || 'WORD_SEARCH';
            } catch (error) {
                Logger.error('Error fetching puzzle type:', error);
            }
        }

        const mapped = result?.content.map((row) => {
            // Calculate percentage based on puzzle type
            let percentage = 0;
            if (row.hidden?.words && row.foundWords) {

                const totalWords = row.hidden.words.split('\n').filter(word => word.trim()).length;
                const foundWordsCount = row.foundWords.split('\n').filter(word => word.trim()).length;

                if (totalWords > 0) {
                    if (puzzleType === 'WORD_SEARCH') {
                        // For WORD_SEARCH: percentage = (foundWords / totalWords) * 100
                        percentage = Math.round((foundWordsCount / totalWords) * 100);
                    } else if (puzzleType === 'HIDDEN_MESSAGE') {
                        // For HIDDEN_MESSAGE: percentage = (foundWords / (totalWords - 1)) * 100
                        // Subtract 1 for the hidden message
                        const targetWords = totalWords - 1;
                        if (targetWords > 0) {
                            percentage = Math.round((foundWordsCount / targetWords) * 100);
                        }
                    }
                }
            }

            return {
                id: row.id,
                foundWords: row.foundWords,
                hidden: row.hidden,
                percentage: percentage,
                name: row.cloudUser?.firstName + " " + (row.cloudUser?.lastName ?? "").trim(),
                email: row.cloudUser?.email,
                startedAt: UtilService.formatDate(row.startedAt),
                finishedAt: UtilService.formatDate(row.finishedAt),
                isCompleted: row.isCompleted,
                attemptsCount: row.attemptsCount,
                hintUsed: row.hintUsed,
                grid: row.grid,
                cloudUser: row.cloudUser,
            };
        });

        setRows(mapped);
        setRowCount(result.page?.totalElements ?? 0);
    },

    deleteGridPlay: async (gridPlayIds) => {
        try {
            // Handle both single ID and multiple IDs
            const ids = Array.isArray(gridPlayIds) ? gridPlayIds : [gridPlayIds];
            await ApiService.deleteData(`/v1/puzzle/grid-play`, { gridPlayIds: ids });
            return true;
        } catch (error) {
            Logger.error('Error deleting hw play:', error);
            throw error;
        }
    },

};

export default AdminGridService;
